import { LucideProps } from "lucide-react";

export const Icons = {
    downloadIcon: ({ ...props }) => (
        <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g clipPath="url(#clip0_276_1477)">
                <path d="M34.875 39H10.125C9.76033 39 9.41059 38.8551 9.15273 38.5973C8.89487 38.3394 8.75 37.9897 8.75 37.625V7.375C8.75 7.01033 8.89487 6.66059 9.15273 6.40273C9.41059 6.14487 9.76033 6 10.125 6H26.625L36.25 15.625V37.625C36.25 37.9897 36.1051 38.3394 35.8473 38.5973C35.5894 38.8551 35.2397 39 34.875 39Z" stroke="#7AE9E5" strokeWidth="2.75" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M26.625 6V15.625H36.25" stroke="#7AE9E5" strokeWidth="2.75" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M22.5 21.125V32.125" stroke="#7AE9E5" strokeWidth="2.75" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M18.375 28L22.5 32.125L26.625 28" stroke="#7AE9E5" strokeWidth="2.75" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_276_1477">
                    <rect width="44" height="44" fill="white" transform="translate(0.5 0.5)" />
                </clipPath>
            </defs>
        </svg>
    ),
    fb: ({ ...props }) => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
            {...props}
        >
            <path
                fill="#fff"
                d="M22 12.304c0-5.557-4.477-10.061-10-10.061S2 6.747 2 12.303c0 5.023 3.657 9.185 8.438 9.94v-7.03h-2.54v-2.91h2.54v-2.216c0-2.521 1.492-3.914 3.777-3.914 1.094 0 2.238.196 2.238.196v2.476h-1.26c-1.243 0-1.63.776-1.63 1.572v1.887h2.773l-.443 2.908h-2.33v7.03c4.78-.754 8.437-4.916 8.437-9.938"
            ></path>
        </svg>
    ),
    insta: ({ ...props }) => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24" {...props}
        >
            <path
                fill="#fff"
                fillRule="evenodd"
                d="M16 3.243H8a5 5 0 0 0-5 5v8a5 5 0 0 0 5 5h8a5 5 0 0 0 5-5v-8a5 5 0 0 0-5-5m3.25 13a3.26 3.26 0 0 1-3.25 3.25H8a3.26 3.26 0 0 1-3.25-3.25v-8A3.26 3.26 0 0 1 8 4.993h8a3.26 3.26 0 0 1 3.25 3.25zm-2.5-7.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2M12 7.743a4.5 4.5 0 1 0 4.5 4.5 4.49 4.49 0 0 0-4.5-4.5m-2.75 4.5a2.75 2.75 0 1 0 5.5 0 2.75 2.75 0 0 0-5.5 0"
                clipRule="evenodd"
            ></path>
        </svg>
    ),
    x: ({ ...props }) => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
            {...props}
        >
            <path
                fill="#fff"
                d="M16 3.243H8a5 5 0 0 0-5 5v8a5 5 0 0 0 5 5h8a5 5 0 0 0 5-5v-8a5 5 0 0 0-5-5m3.25 13a3.26 3.26 0 0 1-3.25 3.25H8a3.26 3.26 0 0 1-3.25-3.25v-8A3.26 3.26 0 0 1 8 4.993h8a3.26 3.26 0 0 1 3.25 3.25zm-2.5-7.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2M12 7.743a4.5 4.5 0 1 0 4.5 4.5 4.49 4.49 0 0 0-4.5-4.5m-2.75 4.5a2.75 2.75 0 1 0 5.5 0 2.75 2.75 0 0 0-5.5 0"
            ></path>
        </svg>
    ),
    linkedIn: ({ ...props }) => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
            {...props}
        >
            <path
                fill="#fff"
                fillRule="evenodd"
                d="M4.5 3.243a1.5 1.5 0 0 0-1.5 1.5v15a1.5 1.5 0 0 0 1.5 1.5h15a1.5 1.5 0 0 0 1.5-1.5v-15a1.5 1.5 0 0 0-1.5-1.5zm4.02 4.002c.006.957-.71 1.546-1.559 1.542a1.5 1.5 0 0 1-1.493-1.54 1.493 1.493 0 0 1 1.54-1.505c.88.02 1.518.665 1.513 1.503m3.76 2.76H9.758v8.56h2.664v-1.34q-.005-1.522.003-3.043c.001-.246.012-.502.075-.737.238-.877 1.027-1.444 1.907-1.304.566.088.94.416 1.097.949.097.333.14.692.145 1.039.012 1.048.01 2.095.008 3.143v1.29h2.671v-1.56q-.003-1.695.001-3.39a6 6 0 0 0-.178-1.507c-.187-.734-.574-1.341-1.203-1.78-.445-.312-.935-.513-1.482-.536l-.188-.01c-.28-.014-.564-.03-.831.024-.765.154-1.437.504-1.945 1.121-.06.07-.117.143-.203.25l-.02.024zm-6.598 8.562h2.65V10.01h-2.65z"
                clipRule="evenodd"
            ></path>
        </svg>
    ),
    youtube: ({ ...props }) => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            fill="none"
            viewBox="0 0 24 24"
            {...props}
        >
            <path
                fill="currentColor"
                d="M21.593 7.203a2.5 2.5 0 0 0-1.762-1.766c-1.566-.43-7.83-.437-7.83-.437s-6.265-.007-7.832.404a2.56 2.56 0 0 0-1.766 1.778c-.413 1.566-.417 4.814-.417 4.814s-.004 3.264.406 4.814c.23.857.905 1.534 1.763 1.765 1.582.43 7.83.437 7.83.437s6.265.007 7.831-.403a2.52 2.52 0 0 0 1.767-1.763c.414-1.565.417-4.812.417-4.812s.02-3.265-.407-4.831M9.996 15.005l.005-6 5.207 3.005z"
            ></path>
        </svg>
    ),
    email: ({ ...props }) => (
        <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M10.5769 14.1729H32.5769V29.7562C32.5769 29.9993 32.4803 30.2325 32.3084 30.4044C32.1365 30.5763 31.9034 30.6729 31.6602 30.6729H11.4936C11.2505 30.6729 11.0173 30.5763 10.8454 30.4044C10.6735 30.2325 10.5769 29.9993 10.5769 29.7562V14.1729Z" stroke="#7AE9E5" strokeWidth="1.69231" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M32.5769 14.1729L21.5769 24.2562L10.5769 14.1729" stroke="#7AE9E5" strokeWidth="1.69231" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    ),
    phone: ({ ...props }) => (
        <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M25.2908 24.5513C25.4232 24.4632 25.5756 24.4095 25.7341 24.3951C25.8925 24.3807 26.0521 24.406 26.1983 24.4688L31.8371 26.9953C32.0271 27.0765 32.1858 27.2171 32.2892 27.396C32.3927 27.5749 32.4354 27.7825 32.411 27.9877C32.2253 29.376 31.5416 30.6495 30.4873 31.5714C29.4329 32.4934 28.0796 33.0011 26.679 33C22.3662 33 18.2301 31.2868 15.1805 28.2372C12.131 25.1876 10.4177 21.0515 10.4177 16.7388C10.4167 15.3382 10.9243 13.9848 11.8463 12.9304C12.7682 11.8761 14.0418 11.1924 15.43 11.0067C15.6352 10.9823 15.8428 11.025 16.0217 11.1285C16.2006 11.232 16.3412 11.3906 16.4224 11.5806L18.9489 17.2242C19.011 17.3692 19.0362 17.5272 19.0225 17.6843C19.0087 17.8414 18.9563 17.9926 18.87 18.1246L16.3148 21.1628C16.2242 21.2995 16.1706 21.4575 16.1593 21.6212C16.1479 21.7848 16.1793 21.9487 16.2502 22.0966C17.2391 24.1209 19.3315 26.1882 21.3618 27.1675C21.5105 27.2381 21.6751 27.2688 21.8392 27.2564C22.0034 27.244 22.1615 27.1891 22.298 27.0969L25.2908 24.5513Z" stroke="#7AE9E5" strokeWidth="1.69231" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    ),
    address: ({ ...props }) => (
        <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M21.5768 18.6156C22.5115 18.6156 23.2691 17.8579 23.2691 16.9233C23.2691 15.9886 22.5115 15.231 21.5768 15.231C20.6422 15.231 19.8845 15.9886 19.8845 16.9233C19.8845 17.8579 20.6422 18.6156 21.5768 18.6156Z" fill="#7AE9E5" />
            <path d="M27.5 16.9231C27.5 22.8462 21.5769 26.2308 21.5769 26.2308C21.5769 26.2308 15.6538 22.8462 15.6538 16.9231C15.6538 15.3522 16.2778 13.8456 17.3886 12.7348C18.4994 11.624 20.006 11 21.5769 11C23.1478 11 24.6543 11.624 25.7651 12.7348C26.8759 13.8456 27.5 15.3522 27.5 16.9231Z" stroke="#7AE9E5" strokeWidth="1.69231" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M29.1923 24.8706C31.2781 25.6406 32.5769 26.7237 32.5769 27.9231C32.5769 30.2595 27.6523 32.1539 21.5769 32.1539C15.5015 32.1539 10.5769 30.2595 10.5769 27.9231C10.5769 26.7237 11.8758 25.6406 13.9615 24.8706" stroke="#7AE9E5" strokeWidth="1.69231" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    ),
    underLine: ({ ...props }) => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="132"
            height="11"
            fill="none"
            viewBox="0 0 132 11"
            {...props}
        >
            <path
                fill="url(#underline-a)"
                d="M0 11c22.224-8.3 79.738-19.922 132 0C112.848 4.782 59.635-3.923 0 11"
            ></path>
            <defs>
                <linearGradient
                    id="underline-a"
                    x1="0"
                    x2="132"
                    y1="5.5"
                    y2="5.5"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4373E0" stopOpacity="0"></stop>
                    <stop offset="1" stopColor="#4373E0"></stop>
                </linearGradient>
            </defs>
        </svg>
    ),
    Be: ({ ...props }) => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="17"
            fill="none"
            viewBox="0 0 17 17"
            {...props}
        >
            <path
                className="fill-[#0C1954] dark:fill-white"
                d="M2.226 8.958h2.581c.574 0 1.552.253 1.552 1.366 0 .574-.455 1.265-1.029 1.265H2.226zM10.51 3.71h4.64v1.57h-4.64zm4.015 5.247h-3.408c.118-.928.81-1.552 1.721-1.552.894-.017 1.552.624 1.687 1.552m-3.509 1.046H16.7v-.27c0-2.16-1.535-3.914-3.863-3.914s-3.88 1.755-3.88 3.914 1.535 3.93 3.88 3.93 3.441-1.35 3.796-3.137H14.54c-.186.91-.726 1.569-1.704 1.569-.962 0-1.754-.911-1.822-2.092m-2.564.523a2.635 2.635 0 0 0-1.755-2.48A2.66 2.66 0 0 0 7.928 5.82c0-1.45-1.147-2.632-2.581-2.632H.168v10.477H5.33c1.704 0 3.12-1.4 3.12-3.138M4.807 7.389h-2.58V5.297h2.58c.574 0 1.046.473 1.046 1.046S5.381 7.39 4.807 7.39"
            ></path>
        </svg>
    ),
    BallIcon: ({ ...props }) => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="17"
            fill="none"
            viewBox="0 0 17 17"
            {...props}
        >
            <path
                className="fill-[#0C1954] dark:fill-white"
                d="M16.515 7.946a7 7 0 0 0-.168-1.35 7.2 7.2 0 0 0-.49-1.552 8.6 8.6 0 0 0-.759-1.4 9 9 0 0 0-1.012-1.215 10 10 0 0 0-1.215-1.012 7.5 7.5 0 0 0-1.4-.76A8.7 8.7 0 0 0 9.92.17 7.8 7.8 0 0 0 8.25 0c-.556 0-1.113.05-1.67.169-.54.1-1.046.27-1.552.489-.49.202-.961.455-1.4.759a9 9 0 0 0-1.215 1.012A10 10 0 0 0 1.4 3.644a7.5 7.5 0 0 0-.759 1.4 8.7 8.7 0 0 0-.49 1.552A8 8 0 0 0 0 7.878v.388c0 .557.05 1.113.169 1.67.1.54.27 1.046.489 1.552.202.49.455.962.759 1.4q.456.659 1.012 1.215c.371.371.793.709 1.215 1.012.438.304.91.557 1.4.76.506.219 1.029.37 1.552.488.54.119 1.113.17 1.67.17s1.113-.051 1.67-.17a7.2 7.2 0 0 0 1.552-.489c.49-.202.962-.472 1.4-.759a9 9 0 0 0 1.215-1.012 10 10 0 0 0 1.012-1.215c.304-.438.557-.91.76-1.4.219-.506.37-1.029.488-1.552.119-.54.17-1.113.17-1.67 0-.118 0-.22-.018-.32M8.266 1.18c1.788 0 3.425.658 4.656 1.754-.017.034-1.029 1.552-3.694 2.564a39 39 0 0 0-2.632-4.116 7.8 7.8 0 0 1 1.67-.202m-3.02.692c.085.134 1.4 1.889 2.615 4.065-3.39.894-6.326.86-6.511.86a7.03 7.03 0 0 1 3.896-4.925m-2.243 11.1a7.08 7.08 0 0 1-1.805-4.724v-.22c.118 0 3.61.085 7.254-1.011.202.405.405.793.573 1.197-.084.034-.185.051-.27.085-3.812 1.231-5.752 4.673-5.752 4.673m5.263 2.345a6.96 6.96 0 0 1-4.335-1.502s-.068-.05-.152-.118c.05.05.101.084.168.118.017-.034 1.367-2.952 5.534-4.403.017 0 .033-.017.05-.017.996 2.581 1.4 4.74 1.502 5.365a7.2 7.2 0 0 1-2.767.557m3.948-1.215c-.068-.422-.456-2.497-1.384-5.044 2.278-.371 4.251.253 4.403.304a7.12 7.12 0 0 1-3.02 4.74m-1.806-6.157c-.05-.119-.1-.237-.151-.372-.101-.253-.22-.489-.338-.742-.05-.101-.084-.185-.135-.287 2.784-1.13 3.914-2.766 3.931-2.8a6.93 6.93 0 0 1 1.569 3.846c.017.186.034.371.034.557-.102.017-2.48-.506-4.91-.202"
            ></path>
        </svg>
    ),
    LinkedIn: ({ ...props }) => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="16"
            fill="none"
            viewBox="0 0 17 16"
            {...props}
        >
            <path
                className="fill-[#0C1954] dark:fill-white"
                d="M16.532 9.683v6.107H12.99v-5.702c0-1.434-.507-2.412-1.789-2.412-.978 0-1.568.658-1.822 1.299-.1.236-.118.54-.118.86v5.955H5.72s.05-9.666 0-10.662H9.26V6.63s-.016.017-.016.033h.016V6.63c.473-.726 1.316-1.755 3.189-1.755 2.328 0 4.082 1.535 4.082 4.808M2.007 0C.793 0 0 .793 0 1.839s.776 1.839 1.957 1.839h.017c1.231 0 2.007-.81 2.007-1.84C3.964.794 3.222 0 2.007 0M.202 15.79h3.543V5.128H.202z"
            ></path>
        </svg>
    ),
    Insta: ({ ...props }) => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="17"
            fill="none"
            viewBox="0 0 17 17"
            {...props}
        >
            <path
                className="fill-[#0C1954] dark:fill-white"
                d="M12.787 16.532H3.745A3.76 3.76 0 0 1 0 12.787V3.745A3.76 3.76 0 0 1 3.745 0h9.042a3.76 3.76 0 0 1 3.745 3.745v9.042a3.76 3.76 0 0 1-3.745 3.745M3.745 1.653a2.09 2.09 0 0 0-2.092 2.092v9.042c0 1.164.945 2.092 2.092 2.092h9.042a2.09 2.09 0 0 0 2.092-2.092V3.745a2.09 2.09 0 0 0-2.092-2.092zm4.521 10.932a4.273 4.273 0 0 1-4.268-4.268 4.26 4.26 0 0 1 4.268-4.268 4.273 4.273 0 0 1 4.268 4.268 4.273 4.273 0 0 1-4.268 4.268m0-6.9a2.635 2.635 0 0 0-2.632 2.632c0 1.45 1.181 2.631 2.632 2.631 1.45 0 2.632-1.18 2.632-2.631S9.717 5.685 8.266 5.685m4.437-2.7c-.59 0-1.08.49-1.08 1.08 0 .608.49 1.08 1.08 1.08s1.08-.489 1.08-1.08c0-.59-.473-1.08-1.08-1.08"
            ></path>
        </svg>
    ),
    Eclipse: () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
            <circle cx="14" cy="14" r="8" fill="#4373E0" />
            <circle cx="14" cy="14" r="11" stroke="#4373E0" strokeOpacity="0.25" strokeWidth="6" />
        </svg>
    ),
    mileStoneBorder: () => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="259"
            height="17"
            fill="none"
            viewBox="0 0 259 17"
        >
            <path
                fill="#4373E0"
                d="M0 17c43.606-12.829 156.455-30.789 259 0C221.421 7.39 117.011-6.063 0 17"
            ></path>
        </svg>
    ),
    MileStoneBorderFaded: () => (
        <svg width="259" height="17" viewBox="0 0 259 17">
            <defs>
                <linearGradient id="maskFade" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" stopColor="white" />
                    <stop offset="100%" stopColor="black" />
                </linearGradient>

                <mask id="fadeMask">
                    <rect width="100%" height="100%" fill="url(#maskFade)" />
                </mask>
            </defs>

            <path
                fill="#4373E0"
                mask="url(#fadeMask)"
                d="M0 17c43.606-12.829 156.455-30.789 259 0C221.421 7.39 117.011-6.063 0 17"
            />
        </svg>

    ),
    MilestoneBg1: () => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="740"
            height="158"
            fill="none"
            viewBox="0 0 740 158"
        >
            <g filter="url(#a)" opacity="0.2">
                <path
                    fill="#4373E0"
                    d="M-556 157.544c218.199-122.25 743.946-283 1296 0-331.232-108.5-710.49-219.78-1296 0"
                ></path>
            </g>
            <defs>
                <filter
                    id="a"
                    width="1296"
                    height="161.544"
                    x="-556"
                    y="0"
                    colorInterpolationFilters="sRGB"
                    filterUnits="userSpaceOnUse"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
                    <feBlend
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                    ></feBlend>
                    <feColorMatrix
                        in="SourceAlpha"
                        result="hardAlpha"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    ></feColorMatrix>
                    <feOffset dy="4"></feOffset>
                    <feGaussianBlur stdDeviation="9.75"></feGaussianBlur>
                    <feComposite
                        in2="hardAlpha"
                        k2="-1"
                        k3="1"
                        operator="arithmetic"
                    ></feComposite>
                    <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"></feColorMatrix>
                    <feBlend in2="shape" result="effect1_innerShadow_404_10960"></feBlend>
                </filter>
            </defs>
        </svg>
    ),
    MilestoneBg2: () => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="720"
            height="158"
            fill="none"
            viewBox="0 0 720 158"
        >
            <g filter="url(#a)" opacity="0.2">
                <path
                    fill="#4373E0"
                    d="M0 0c218.199 122.249 743.946 283 1296 0C964.768 108.5 585.509 219.779 0 0"
                ></path>
            </g>
            <defs>
                <filter
                    id="a"
                    width="1296"
                    height="161.544"
                    x="0"
                    y="0"
                    colorInterpolationFilters="sRGB"
                    filterUnits="userSpaceOnUse"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
                    <feBlend
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                    ></feBlend>
                    <feColorMatrix
                        in="SourceAlpha"
                        result="hardAlpha"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    ></feColorMatrix>
                    <feOffset dy="4"></feOffset>
                    <feGaussianBlur stdDeviation="9.75"></feGaussianBlur>
                    <feComposite
                        in2="hardAlpha"
                        k2="-1"
                        k3="1"
                        operator="arithmetic"
                    ></feComposite>
                    <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"></feColorMatrix>
                    <feBlend in2="shape" result="effect1_innerShadow_404_10984"></feBlend>
                </filter>
            </defs>
        </svg>
    ),
    VideoPlay: () => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="37"
            height="40"
            fill="none"
            viewBox="0 0 37 40"
        >
            <g filter="url(#a)">
                <path
                    fill="#D9D9D9"
                    d="M2.469 36.275a.74.74 0 0 0 1.095.65l30.305-16.53a.74.74 0 0 0 0-1.3L3.564 2.564a.74.74 0 0 0-1.095.65z"
                ></path>
            </g>
            <path
                stroke="#fff"
                strokeWidth="4.938"
                d="M2.469 36.275a.74.74 0 0 0 1.095.65l30.305-16.53a.74.74 0 0 0 0-1.3L3.564 2.564a.74.74 0 0 0-1.095.65z"
            ></path>
            <defs>
                <filter
                    id="a"
                    width="36.723"
                    height="40.97"
                    x="0"
                    y="0"
                    colorInterpolationFilters="sRGB"
                    filterUnits="userSpaceOnUse"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
                    <feBlend
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                    ></feBlend>
                    <feColorMatrix
                        in="SourceAlpha"
                        result="hardAlpha"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    ></feColorMatrix>
                    <feOffset dy="1.481"></feOffset>
                    <feGaussianBlur stdDeviation="3.519"></feGaussianBlur>
                    <feComposite
                        in2="hardAlpha"
                        k2="-1"
                        k3="1"
                        operator="arithmetic"
                    ></feComposite>
                    <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"></feColorMatrix>
                    <feBlend in2="shape" result="effect1_innerShadow_1002_1055"></feBlend>
                </filter>
            </defs>
        </svg>
    ),
    ResourceViewAll: (props: React.SVGProps<SVGSVGElement>) => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="131"
            height="122"
            fill="none"
            viewBox="0 0 131 122"
            className="group"
            {...props}
        >
            <path
                fill="#11C0D3"
                fillOpacity="0.4"
                d="M.81 40.41V28.663h83.864l8.507 8.508v31.6H81.028v-9.723c0-5.267 0-9.723-.405-9.723L8.508 121.438 0 112.93l36.057-36.057C55.91 57.02 72.114 40.816 72.114 40.41z"
            ></path>
            <path
                className=" group-hover:opacity-0"
                fill="#4373E0"
                d="M10.07 98.666 5.134 93.73l3.109-3.108.627.627L6.51 93.61l1.388 1.39 2.045-2.045.62.62-2.044 2.045 1.67 1.67 2.362-2.361.627.627zm6.234-6.235-1.106-4.237-3.617-.91.84-.838 2.544.642-.698-2.489.846-.846.93 3.595 4.265 1.079-.838.839-3.18-.797.867 3.109zm7.233-7.232-4.935-4.935 1.727-1.727q.522-.522 1.065-.74a1.83 1.83 0 0 1 1.078-.106q.536.099 1.008.571.473.472.578 1.015t-.12 1.093q-.225.536-.733 1.043l-.98.98 2.059 2.058zm-1.946-3.44.966-.966q.528-.529.536-.959 0-.437-.374-.81-.381-.381-.81-.374-.438 0-.966.528l-.966.966zm8.635-3.25-4.935-4.934.747-.747 4.314 4.314 2.214-2.213.62.62zm8.204-8.034q-.529.528-1.163.796a3.5 3.5 0 0 1-1.319.261 3.5 3.5 0 0 1-1.325-.282 4 4 0 0 1-1.22-.853 4 4 0 0 1-.852-1.22 3.5 3.5 0 0 1-.29-1.332q0-.676.268-1.31.268-.635.797-1.164a3.7 3.7 0 0 1 1.17-.804q.627-.275 1.297-.267.676 0 1.333.288.655.276 1.233.854.57.57.853 1.233.29.656.29 1.332 0 .663-.269 1.297a3.7 3.7 0 0 1-.803 1.17m-.67-.67q.486-.486.649-1.1.162-.614-.036-1.261-.197-.65-.782-1.234-.6-.6-1.248-.797a2.2 2.2 0 0 0-1.255-.028 2.5 2.5 0 0 0-1.092.656q-.48.48-.642 1.092a2.2 2.2 0 0 0 .028 1.255q.198.648.79 1.24.585.586 1.234.783.648.198 1.261.035a2.4 2.4 0 0 0 1.093-.641m6.4-5.23-4.934-4.935 1.587-1.586q.52-.522 1.05-.726.528-.22 1.043-.113.515.105.973.564.557.556.578 1.156.015.592-.38 1.198l3.658.867-.902.903-3.377-.896-.684.684 2.136 2.136zm-2.022-3.518.825-.825q.352-.352.465-.649a.75.75 0 0 0 .02-.542 1.35 1.35 0 0 0-.33-.5 1.3 1.3 0 0 0-.494-.325.74.74 0 0 0-.55.014q-.295.112-.648.465l-.825.825zm8.815-3.275-4.934-4.934 3.108-3.11.628.628-2.362 2.362 1.389 1.389 2.044-2.045.62.62-2.044 2.045 1.67 1.67 2.362-2.361.628.627z"
            ></path>
            <path
                fill="#11C0D3"
                fillOpacity="0.4"
                d="M94.805 80.924V68.77h12.154v12.154zM81.43 121.033V80.519h12.154v40.109H81.43z"
            ></path>
        </svg>
    ),
    ResourceViewAll2: () => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="209"
            height="195"
            fill="none"
            viewBox="0 0 209 195"
        >
            <path
                fill="#4373E0"
                d="M1.574 37.509V14.687h162.9L181 31.213v61.383h-23.609V73.709c0-10.23 0-18.887-.787-18.887L16.526 194.9 0 178.374l70.04-70.039c38.56-38.561 70.038-70.04 70.038-70.826z"
            ></path>
            <path fill="#4373E0" d="M157.34 116.204V92.595h23.609v23.609z"></path>
            <path
                fill="#4373E0"
                d="M157.34 194.113v-78.696h23.609v77.909H157.34z"
            ></path>
        </svg>
    ),
    faceBook: (props: LucideProps) => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="157"
            height="157"
            fill="none"
            viewBox="0 0 24 24"
            {...props}
        >
            <path
                fill="#fff"
                d="M20 12.05a8 8 0 1 0-9.25 8v-5.67h-2v-2.33h2v-1.77a2.83 2.83 0 0 1 3-3.14q.901.013 1.79.16v2h-1a1.16 1.16 0 0 0-1.3 1.26v1.51h2.22l-.36 2.33h-1.85V20A8 8 0 0 0 20 12.05"
            ></path>
        </svg>
    ),
    VideoPlay1: () => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="120"
            height="120"
            fill="none"
            viewBox="0 0 120 120"
        >
            <path
                fill="#fff"
                d="M59.967 0C26.985 0 0 26.985 0 59.967s26.985 59.967 59.967 59.967 59.967-26.985 59.967-59.967S92.949 0 59.967 0m23.487 64.964-33.481 17.99c-3.998 2-8.496-.5-8.496-4.997v-35.98c0-4.498 4.998-7.496 8.496-4.997l33.481 17.99c4.498 1.999 4.498 7.995 0 9.994"
            ></path>
        </svg>
    ),
    CustomAccordionIcon: ({ ...props }) => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="36"
            height="36"
            fill="none"
            viewBox="0 0 36 36"
            {...props}
        >
            <rect
                width="35"
                height="35"
                x="0.5"
                y="0.5"
                fill="#fff"
                fillOpacity="0.05"
                rx="17.5"
            ></rect>
            <rect
                width="35"
                height="35"
                x="0.5"
                y="0.5"
                stroke="url(#a)"
                rx="17.5"
            ></rect>
            <path
                fill="#000"
                d="M18.663 11.316q-.061-.68-.741-.742-.68.062-.742.742v4.943h-4.942q-.68.061-.742.74.061.68.742.742h4.942v4.943q.063.68.742.742.68-.062.741-.742v-4.943h4.943q.68-.06.741-.741-.061-.68-.74-.741h-4.944z"
            ></path>
            <defs>
                <linearGradient
                    id="a"
                    x1="18"
                    x2="18"
                    y1="0"
                    y2="36"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4373E0"></stop>
                    <stop offset="1" stopColor="#243F7A"></stop>
                </linearGradient>
            </defs>
        </svg>
    ),
    ResorceVideoIcon: (props: React.SVGProps<SVGSVGElement>) => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="78"
            height="73"
            fill="none"
            viewBox="0 0 78 73"
            {...props}
        >
            <path fill="#4373E0" d="M3-3h78v73H3z"></path>
            <path stroke="#4373E0" strokeWidth="6" d="M3-3h78v73H3z"></path>
            <path
                fill="#fff"
                d="M41.734 12C29.78 12 20 21.78 20 33.734S29.78 55.47 41.734 55.47s21.735-9.78 21.735-21.735S53.689 12 41.734 12m8.513 23.546-12.135 6.52c-1.449.724-3.08-.181-3.08-1.811v-13.04c0-1.631 1.812-2.718 3.08-1.812l12.135 6.52c1.63.725 1.63 2.898 0 3.623"
            ></path>
        </svg>
    ),
    ResourceArrow: (props: React.SVGProps<SVGSVGElement>) => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="78"
            height="73"
            fill="none"
            viewBox="0 0 78 73"
            {...props}
        >
            <g clipPath="url(#a)">
                <path fill="#4373E0" d="M6 0h72v67H6z"></path>
                <path
                    fill="#fff"
                    d="M3.466 23.23v-6.753h48.21l4.891 4.89v18.167H49.58v-5.59c0-3.028 0-5.59-.233-5.59L7.891 69.812 3 64.92l20.728-20.728C35.14 32.78 44.456 23.464 44.456 23.23zM57.5 46.52v-6.987h6.987v6.987zM49.813 69.578v-23.29h6.986v23.057h-6.986z"
                ></path>
            </g>
            <path stroke="#4373E0" strokeWidth="6" d="M3-3h78v73H3z"></path>
            <defs>
                <clipPath id="a">
                    <path fill="#fff" d="M6 0h72v67H6z"></path>
                </clipPath>
            </defs>
        </svg>
    ),
    ResourceArrow2: (props: React.SVGProps<SVGSVGElement>) => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="54"
            height="54"
            fill="none"
            viewBox="0 0 54 54"
            {...props}
        >
            <path
                fill="#fff"
                d="M.466 6.754V0h48.21L54 5.023v18.034h-7V11.523s-9.969 9.671-42.11 41.811L0 48.444l20.728-20.729C32.14 16.303 41.456 6.987 41.456 6.755z"
            ></path>
            <path fill="#fff" d="M47 30.044v-6.987h6.987v6.987z"></path>
            <path fill="#fff" d="M47 53.102V29.81h6.987V52.87H47z"></path>
        </svg>
    ),
    ResourceVideo2: (props: React.SVGProps<SVGSVGElement>) => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="55"
            height="55"
            fill="none"
            viewBox="0 0 55 55"
            {...props}
        >
            <path
                fill="#fff"
                d="M27.5 0C12.375 0 0 12.375 0 27.5S12.375 55 27.5 55 55 42.625 55 27.5 42.625 0 27.5 0m10.77 29.792-15.353 8.25c-1.834.916-3.896-.23-3.896-2.292v-16.5c0-2.062 2.291-3.437 3.896-2.292l15.354 8.25c2.062.917 2.062 3.667 0 4.584"
            ></path>
        </svg>
    ),
    ServiceArrow: () => (
        <svg
            className="w-[62px] h-[58px] fill-current text-black/40 dark:text-[#FFFFFF66] dark:bg-[#FFFFFF0D] dark:group-hover:text-primary
               transition-all duration-300 ease-out
               group-hover:scale-150
               group-hover:text-[#4373E0]
               group-hover:drop-shadow-[0_10px_20px_rgba(255,77,0,0.4)]"
            viewBox="0 0 62 58"
            xmlns="http://www.w3.org/2000/svg"
        >
            {/* Path 1 */}
            <path d="M0.385776 19.2397V16.3464V13.6459H40.3135L44.3642 17.6966V32.7418H38.5775V28.1125C38.5775 25.605 38.5775 23.4832 38.3847 23.4832C38.3847 23.4832 30.6691 31.1987 4.05064 57.8172L0 53.7666L17.167 36.5996C26.6185 27.1481 34.334 19.4326 34.334 19.2397C34.334 19.2397 26.6185 19.2397 0.385776 19.2397Z" />

            {/* Path 2 — fades out */}
            <path
                className="transition-opacity duration-300 group-hover:opacity-0"
                d="M9.82395 40.1269L6.60533 38.6468L6.98794 38.2642L9.66956 39.5429L8.39755 36.8545L8.77345 36.4786L10.2535 39.6973L9.82395 40.1269ZM12.6186 37.3322L10.2693 34.9828L10.625 34.6271L12.9744 36.9764L12.6186 37.3322ZM14.6463 35.3045L12.2969 32.9552L13.777 31.4751L14.0757 31.7738L12.9514 32.8981L13.6125 33.5593L14.5858 32.586L14.8812 32.8814L13.9079 33.8547L14.7033 34.6501L15.8276 33.5257L16.1263 33.8245L14.6463 35.3045ZM18.4102 31.5406L15.2352 30.0169L15.5977 29.6544L18.286 30.9936L17.6886 29.7853L16.1884 29.0637L16.5475 28.7046L17.6382 29.2651L17.0778 28.1743L17.4402 27.8119L18.1585 29.3154L19.3667 29.9129L18.0276 27.2245L18.39 26.8621L19.9138 30.037L19.4976 30.4532L18.1987 29.8256L18.8263 31.1245L18.4102 31.5406Z"
            />

            {/* Path 3 — slides left */}
            <path
                className="transition-transform duration-300 ease-out group-hover:-translate-x-[6.5px]"
                d="M45.1367 38.5284V35.6351V32.7418H50.9234V38.5284H45.1367Z"
            />

            {/* Path 4 */}
            <path d="M38.7695 57.6243V47.9799V38.3355H44.5562V57.4314H38.7695V57.6243Z" />
        </svg>
    ),
    WhatisPlayer: (props: LucideProps) => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="120"
            height="120"
            fill="none"
            viewBox="0 0 120 120"
            {...props}
        >
            <path
                fill="#fff"
                d="M59.967 0C26.985 0 0 26.985 0 59.967s26.985 59.967 59.967 59.967 59.967-26.985 59.967-59.967S92.949 0 59.967 0m23.487 64.964-33.481 17.99c-3.998 2-8.496-.5-8.496-4.997v-35.98c0-4.498 4.998-7.496 8.496-4.997l33.481 17.99c4.498 1.999 4.498 7.995 0 9.994"
                opacity="0.5"
            ></path>
        </svg>
    ),
    reviewIcon: () => (
        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="56" height="57" viewBox="0 0 56 57" fill="none">
            <path d="M55.177 0H0V57H55.177V0Z" fill="url(#pattern0_1438_2991)" />
            <defs>
                <pattern id="pattern0_1438_2991" patternContentUnits="objectBoundingBox" width="1" height="1">
                    <use xlinkHref="#image0_1438_2991" transform="matrix(0.00341297 0 0 0.00330382 0 0.00277571)" />
                </pattern>
                <image id="image0_1438_2991" width="293" height="301" preserveAspectRatio="none" xlinkHref="data:image/png;base64,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" />
            </defs>
        </svg>
    ),
    reviewStar: () => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="27"
            fill="none"
            viewBox="0 0 28 27"
        >
            <path
                fill="#EB583C"
                d="M12.628.638a1.135 1.135 0 0 1 2.04 0l3.337 6.796c.165.337.485.571.855.625l7.462 1.097c.933.137 1.305 1.29.63 1.952l-5.398 5.287a1.15 1.15 0 0 0-.327 1.012l1.273 7.468c.16.934-.816 1.647-1.65 1.206l-6.672-3.528a1.13 1.13 0 0 0-1.059 0L6.448 26.08c-.835.441-1.81-.271-1.651-1.206l1.274-7.468c.063-.37-.06-.75-.328-1.012L.345 11.108c-.675-.662-.303-1.815.63-1.952L8.436 8.06c.37-.054.69-.288.855-.625z"
            ></path>
        </svg>
    ),
    reviewStarHalf: () => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="27"
            fill="none"
            viewBox="0 0 28 27"
        >
            <path
                fill="#D2DAEA"
                d="M12.628.638a1.135 1.135 0 0 1 2.04 0l3.337 6.796c.165.337.485.571.855.625l7.462 1.097c.933.137 1.305 1.29.63 1.952l-5.398 5.287a1.15 1.15 0 0 0-.327 1.012l1.273 7.468c.16.934-.816 1.647-1.65 1.206l-6.672-3.528a1.13 1.13 0 0 0-1.059 0L6.448 26.08c-.835.441-1.81-.271-1.651-1.206l1.274-7.468c.063-.37-.06-.75-.328-1.012L.345 11.108c-.675-.662-.303-1.815.63-1.952L8.436 8.06c.37-.054.69-.288.855-.625z"
            ></path>
            <mask
                id="a"
                width="28"
                height="27"
                x="0"
                y="0"
                maskUnits="userSpaceOnUse"
                style={{ maskType: "luminance" }}
            >
                <path
                    fill="#FBB138"
                    d="M12.628.638a1.135 1.135 0 0 1 2.04 0l3.337 6.796c.165.337.485.571.855.625l7.462 1.097c.933.137 1.305 1.29.63 1.952l-5.398 5.287a1.15 1.15 0 0 0-.327 1.012l1.273 7.468c.16.934-.816 1.647-1.65 1.206l-6.672-3.528a1.13 1.13 0 0 0-1.059 0L6.448 26.08c-.835.441-1.81-.271-1.651-1.206l1.274-7.468c.063-.37-.06-.75-.328-1.012L.345 11.108c-.675-.662-.303-1.815.63-1.952L8.436 8.06c.37-.054.69-.288.855-.625z"
                ></path>
            </mask>
            <g mask="url(#a)">
                <path fill="#EB583C" d="M19.88-5.387H-2.793v42.093H19.88z"></path>
            </g>
        </svg>
    ),
    Twitter: () => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="17"
            fill="none"
            viewBox="0 0 21 17"
        >
            <path
                fill="#fff"
                d="M20.383 1.967a8.4 8.4 0 0 1-2.402.658 4.2 4.2 0 0 0 1.84-2.314c-.82.488-1.719.83-2.656 1.015a4.182 4.182 0 0 0-7.126 3.814A11.87 11.87 0 0 1 1.419.77a4.17 4.17 0 0 0-.566 2.103c0 1.45.738 2.731 1.86 3.481a4.2 4.2 0 0 1-1.894-.523v.052a4.185 4.185 0 0 0 3.355 4.101 4.2 4.2 0 0 1-1.89.072 4.185 4.185 0 0 0 3.907 2.905A8.4 8.4 0 0 1 0 14.693a11.83 11.83 0 0 0 6.41 1.88c7.693 0 11.9-6.373 11.9-11.9q0-.271-.013-.54a8.5 8.5 0 0 0 2.087-2.165z"
            ></path>
        </svg>
    ),
    Arthaverse: () => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="737"
            height="184"
            fill="none"
            viewBox="0 0 737 184"

        >
            <path
                fill="#00020F"
                fillRule="evenodd"
                d="M337.121 94.536q10.117 0 17.817 3.934 7.701 3.776 11.928 10.7 4.379 6.767 4.379 15.893v56.962h-18.723v-8.98a33 33 0 0 1-3.322 3.316q-4.378 3.62-9.965 5.664-5.586 1.889-12.381 1.889-8.606 0-14.948-2.99-6.341-2.99-9.814-8.497-3.473-5.665-3.473-13.061 0-7.08 3.02-12.588 3.02-5.664 9.361-9.441t16.005-5.351l24.461-4.153v-2.77q0-5.507-4.229-9.126-4.076-3.777-10.871-3.777-6.34 0-11.324 3.619-4.832 3.462-7.097 9.284l-16.155-8.182q2.416-6.767 7.55-11.645 5.284-5.035 12.381-7.868 7.096-2.832 15.4-2.832m-6.341 52.714q-5.888 1.1-8.758 3.934t-2.869 7.396q0 4.406 3.171 7.081 3.322 2.518 8.154 2.518 6.19 0 10.872-2.676 4.83-2.832 7.398-7.71 2.718-4.878 2.718-10.7v-3.507zM498.633 94.536q9.662 0 16.91 3.305 7.399 3.304 12.532 9.126 5.134 5.822 7.852 13.376 2.718 7.395 2.718 16.05 0 2.202-.302 4.563-.152 2.36-.755 4.091h-59.18q.38 4.417 1.954 8.182 2.719 5.98 7.852 9.285 5.284 3.304 12.079 3.304t11.476-2.99q4.832-2.99 7.549-8.024l16.005 8.181q-2.415 6.137-7.55 10.858-5.133 4.721-12.23 7.396-6.946 2.675-15.4 2.675-12.683 0-22.196-5.979-9.512-5.98-14.798-16.208-5.284-10.228-5.284-22.66 0-12.903 5.284-22.816 5.437-10.07 14.647-15.893 9.362-5.822 20.837-5.822m0 16.994q-6.191 0-11.023 3.305-4.832 3.147-7.398 9.441a26.4 26.4 0 0 0-1.398 5.036h38.688q-.24-2.918-1.204-5.507-1.963-5.666-6.644-8.97-4.529-3.305-11.021-3.305"
                clipRule="evenodd"
            ></path>
            <path
                fill="#00020F"
                d="M622.272 94.536q11.627 0 20.536 5.822 8.908 5.823 12.682 16.366l-15.098 7.395q-2.114-5.822-7.097-9.284t-11.173-3.462q-4.983 0-7.851 2.36-2.87 2.361-2.87 6.137 0 2.361 1.208 4.092 1.209 1.731 3.322 2.832 2.264 1.101 5.133 2.046l13.137 4.091q10.116 3.147 15.552 9.441 5.586 6.294 5.586 15.421 0 7.71-3.925 13.689-3.926 5.823-10.872 9.127t-16.307 3.305q-13.135 0-22.95-6.451-9.663-6.609-13.287-17.781l14.797-7.397q3.17 7.24 8.758 11.33 5.737 4.091 12.682 4.091 5.436 0 8.607-2.518t3.171-6.608q0-2.518-1.36-4.092-1.208-1.73-3.472-2.832-2.115-1.258-4.681-2.046l-13.438-3.933q-10.418-3.147-15.854-9.599-5.284-6.451-5.284-15.264 0-7.867 3.774-13.689 3.926-5.98 10.721-9.284 6.946-3.305 15.853-3.305"
            ></path>
            <path
                fill="#00020F"
                fillRule="evenodd"
                d="M696.24 94.536q9.663 0 16.91 3.305 7.399 3.304 12.533 9.126t7.851 13.376q2.718 7.395 2.718 16.05 0 2.202-.302 4.563-.15 2.36-.755 4.091h-59.179q.38 4.417 1.954 8.182 2.718 5.98 7.851 9.285 5.285 3.304 12.079 3.304 6.796 0 11.476-2.99 4.832-2.99 7.55-8.024l16.005 8.181q-2.417 6.137-7.55 10.858-5.135 4.721-12.231 7.396-6.945 2.675-15.4 2.675-12.683 0-22.195-5.979-9.513-5.98-14.798-16.208-5.284-10.228-5.284-22.66 0-12.903 5.284-22.816 5.436-10.07 14.646-15.893 9.362-5.822 20.837-5.822m0 16.994q-6.19 0-11.022 3.305-4.831 3.147-7.399 9.441a26.3 26.3 0 0 0-1.397 5.036h38.687q-.239-2.918-1.204-5.507-1.962-5.666-6.643-8.97-4.53-3.305-11.022-3.305"
                clipRule="evenodd"
            ></path>
            <path
                fill="#00020F"
                d="M193.023 96.425h18.874v18.411h-18.874V151.5q0 4.248 1.36 7.238 1.51 2.99 4.529 4.563 3.17 1.574 8.002 1.574 1.057 0 2.416-.157 1.51-.158 2.869-.316v17.624q-2.114.315-4.832.63t-4.982.315q-13.891 0-21.592-7.868-7.55-8.026-7.549-22.502v-38.834h-14.193V96.425h1.51q6.039 0 9.361-3.304 3.321-3.305 3.322-9.599v-6.609h19.779zM590.216 113.733h-7.097q-8.455 0-13.589 5.508-5.134 5.35-5.134 15.107v47.678h-19.779V96.425h18.571v12.052q2.767-6.323 7.399-9.22 6.19-3.777 14.798-3.777h4.831z"
            ></path>
            <path
                fill="#00020F"
                fillRule="evenodd"
                d="M110.852 182.025H87.075l-8.514-24.81H32.292l-8.676 24.81H0L41.288 66.5h28.276zm-72.295-43.419h33.738l-16.87-48.714z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#00020F"
                d="M129.427 108.477q2.766-6.324 7.398-9.221c4.127-2.518 9.071-2.832 14.809-2.832h4.82v17.309h-7.097q-8.454 0-13.588 5.507-5.134 5.35-5.134 15.107v47.678h-19.78V96.424h18.572zM237.843 107.262q2.786-3.76 7.04-6.119 7.04-3.969 16.318-3.968 9.6 0 16.959 3.968 7.52 3.967 11.679 11.14 4.16 7.02 4.16 16.329v53.413h-20.958v-48.682q0-5.494-2.24-9.462t-6.239-6.105q-3.84-2.289-9.121-2.289-5.118 0-9.119 2.289-4 2.137-6.239 6.105-2.24 3.968-2.24 9.462v48.682h-20.958V66.5h20.958zM424.127 155.375 453.895 66.5h23.249l-40.686 115.525h-24.505L371.111 66.5h23.248zM61.748 57c103.965-44.23 354.465-102.39 617.5 0-157.821-39.256-338.525-79.517-617.5 0"
            ></path>
        </svg>
    ),
    JobCategory: ({ ...props }: LucideProps) => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
            {...props}
        >
            <g
                stroke=""
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="22.926"
                strokeWidth="2"
                clipPath="url(#a)"
            >
                <path d="M6.563 5.719V3.63c0-.83.68-1.51 1.51-1.51h7.854c.83 0 1.51.68 1.51 1.51V5.72M22.36 12.469v8.004a1.41 1.41 0 0 1-1.407 1.406H3.047a1.41 1.41 0 0 1-1.406-1.406v-7.957"></path>
                <path d="M10.125 14.836C5.166 14.552.703 13.134.703 10.582V7.254c0-.775.632-1.406 1.406-1.406h19.782a1.41 1.41 0 0 1 1.406 1.406v3.328c0 2.568-4.52 3.988-9.516 4.26"></path>
                <path
                    d="M10.266 13.441h3.468v1.618c0 .889-.727 1.617-1.617 1.617h-.234c-.89 0-1.617-.728-1.617-1.617z"
                    clipRule="evenodd"
                ></path>
            </g>
            <defs>
                <clipPath id="a">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                </clipPath>
            </defs>
        </svg>
    ),
    JobType: ({ ...props }: LucideProps) => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
            {...props}
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10"
            ></path>
            <path
                stroke=""
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 6v6l4 2"
            ></path>
        </svg>
    ),
    JobSalary: ({ ...props }: LucideProps) => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
            {...props}
        >
            <mask
                id="jobSalary"
                width="24"
                height="24"
                x="0"
                y="0"
                maskUnits="userSpaceOnUse"
                style={{ maskType: "luminance" }}
            >
                <path fill="#fff" d="M0 0h24v24H0z"></path>
            </mask>
            <g stroke="currentColor" strokeMiterlimit="10" strokeWidth="2" mask="url(#jobSalary)">
                <path d="M19.309 6.373V4.496a1.873 1.873 0 0 0-1.873-1.873H2.809a1.875 1.875 0 0 0 0 3.75h18.377c1.034 0 1.873.839 1.873 1.873v2.814"></path>
                <path d="M23.059 16.686V19.5a1.873 1.873 0 0 1-1.873 1.873H2.809a1.875 1.875 0 0 1-1.875-1.875v-15"></path>
                <path d="M23.059 16.686H18.37a2.813 2.813 0 0 1 0-5.626h4.688z"></path>
            </g>
        </svg>
    ),
    JobLocation: ({ ...props }: LucideProps) => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
            {...props}
        >
            <g
                stroke=""
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                clipPath="url(#jobLocation)"
            >
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 1 1 18 0"></path>
                <path d="M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6"></path>
            </g>
            <defs>
                <clipPath id="jobLocation">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                </clipPath>
            </defs>
        </svg>
    ),
    CareerViewAll: () => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="62"
            height="58"
            fill="none"
            viewBox="0 0 62 58"
        >
            <path
                fill="#11C0D3"
                fillOpacity="0.4"
                d="M.386 19.24v-5.594h39.927l4.051 4.05v15.046h-5.786v-4.63c0-2.507 0-4.629-.193-4.629L4.05 57.817 0 53.767 17.167 36.6c9.452-9.452 17.167-17.167 17.167-17.36z"
            ></path>
            <path
                fill="#4373E0"
                d="m9.826 40.127-3.219-1.48.383-.383 2.682 1.279L8.4 36.855l.375-.376 1.48 3.218zm2.795-2.795-2.35-2.35.356-.355 2.35 2.35zm2.027-2.028-2.35-2.349 1.48-1.48.3.299-1.125 1.124.662.661.973-.973.295.295-.973.974.795.795 1.125-1.124.298.298zm3.764-3.763-3.175-1.524.363-.363 2.688 1.34-.598-1.209-1.5-.721.36-.36 1.09.561-.56-1.09.362-.363.718 1.503 1.209.598-1.34-2.689.363-.362 1.524 3.175-.416.416-1.3-.627.628 1.299z"
            ></path>
            <path
                fill="#11C0D3"
                fillOpacity="0.4"
                d="M45.137 38.528v-5.786h5.786v5.786zM38.77 57.624V38.335h5.786v19.096H38.77z"
            ></path>
        </svg>

    ),
    CareerViewAllHover: () => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="62"
            height="58"
            fill="none"
            viewBox="0 0 62 58"
        >
            <path
                fill="#4373E0"
                d="M.467 11.127v-6.77H48.79l4.903 4.902v18.21H46.69v-5.603c0-3.035 0-5.603-.233-5.603L4.902 57.817 0 52.915l20.777-20.777c11.44-11.44 20.777-20.777 20.777-21.011z"
            ></path>
            <path fill="#4373E0" d="M46.676 34.472v-7.003h7.003v7.003z"></path>
            <path fill="#4373E0" d="M46.676 57.584V34.239h7.003V57.35h-7.003z"></path>
        </svg>
    ),
    ButtonArrow: ({ ...props }: LucideProps) => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="9"
            fill="none"
            viewBox="0 0 15 9"
            {...props}
        >
            <path
                fill="currentColor"
                d="M10.32.15q.297-.3.563 0l3.85 3.848q.297.266 0 .531l-3.85 3.85q-.265.297-.564 0l-.232-.233q-.3-.266 0-.564l2.787-2.754H.398Q0 4.828 0 4.43v-.332Q0 3.7.398 3.7h12.476L10.087.946q-.3-.3 0-.564z"
            ></path>
        </svg>
    ),
    FileUpload: () => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="69"
            height="60"
            fill="none"
            viewBox="0 0 69 60"
        >
            <path
                fill="#483EA8"
                stroke="#F9FFF9"
                strokeWidth="0.3"
                d="M46.099 5.701a.882.882 0 0 1 0 1.764c-4.113 0-7.803 2.75-8.975 6.687a.88.88 0 0 1-1.001.617l-.004.004-.092-.027a.88.88 0 0 1-.593-1.097c1.363-4.582 5.61-7.948 10.665-7.948Z"
            ></path>
            <path
                fill="#483EA8"
                d="M56.344 42.438h-4.39a.732.732 0 0 1 0-1.463h4.39c6.052 0 10.976-4.924 10.976-10.976s-4.924-10.976-10.976-10.976h-.106a.73.73 0 0 1-.724-.836c.065-.456.098-.913.098-1.36 0-5.244-4.268-9.512-9.513-9.512-2.04 0-3.986.638-5.627 1.845a.732.732 0 0 1-1.081-.25C34.743.06 22.602-1.129 16.308 6.57a13.86 13.86 0 0 0-2.858 11.576.732.732 0 0 1-.717.878h-.293C6.388 19.024 1.463 23.948 1.463 30c0 6.051 4.924 10.975 10.976 10.975h4.39a.732.732 0 0 1 0 1.464h-4.39C5.58 42.439 0 36.859 0 29.999c0-6.666 5.272-12.125 11.865-12.426-.62-4.266.565-8.57 3.31-11.929 6.739-8.244 19.653-7.32 25.112 1.873A10.9 10.9 0 0 1 46.1 5.852c6.355 0 11.39 5.409 10.95 11.728 6.532.366 11.734 5.796 11.734 12.419 0 6.86-5.58 12.44-12.44 12.44"
            ></path>
            <path
                fill="#483EA8"
                stroke="#F9FFF9"
                strokeWidth="0.3"
                d="M34.294 22.85c10.17 0 18.443 8.274 18.443 18.444s-8.273 18.443-18.443 18.443S15.85 51.464 15.85 41.294 24.124 22.85 34.294 22.85Zm0 1.764c-9.197 0-16.68 7.483-16.68 16.68s7.483 16.68 16.68 16.68 16.68-7.483 16.68-16.68-7.483-16.68-16.68-16.68Z"
            ></path>
            <path
                fill="#483EA8"
                stroke="#483EA8"
                strokeWidth="0.3"
                d="M34.626 34.043c.378 0 .686.308.686.687v13.927a.687.687 0 1 1-1.372 0V34.73c0-.38.307-.687.686-.687Z"
            ></path>
            <path
                fill="#483EA8"
                stroke="#483EA8"
                strokeWidth="0.3"
                d="M34.142 34.246a.686.686 0 0 1 .97 0l4.285 4.286a.686.686 0 0 1 0 .97l-.002-.001a.68.68 0 0 1-.968.001L34.626 35.7l-3.8 3.802a.686.686 0 0 1-.97-.97z"
            ></path>
        </svg>
    ),
    Google: () => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
        >
            <path
                fill="#FFC107"
                d="M21.806 10.042H21V10h-9v4h5.651A5.998 5.998 0 0 1 6 12a6 6 0 0 1 6-6c1.53 0 2.921.577 3.98 1.52L18.81 4.69A9.95 9.95 0 0 0 12 2C6.478 2 2 6.478 2 12s4.478 10 10 10 10-4.477 10-10c0-.67-.069-1.325-.195-1.959"
            ></path>
            <path
                fill="#FF3D00"
                d="m3.153 7.346 3.286 2.409A6 6 0 0 1 12 6c1.53 0 2.921.577 3.98 1.52L18.81 4.69A9.95 9.95 0 0 0 12 2a9.99 9.99 0 0 0-8.847 5.346"
            ></path>
            <path
                fill="#4CAF50"
                d="M12 22c2.583 0 4.93-.988 6.704-2.596l-3.094-2.619A5.95 5.95 0 0 1 12 18a6 6 0 0 1-5.642-3.973l-3.26 2.513C4.751 19.778 8.112 22 12 22"
            ></path>
            <path
                fill="#1976D2"
                d="M21.806 10.042H21V10h-9v4h5.651a6 6 0 0 1-2.043 2.785h.002l3.095 2.619C18.485 19.602 22 17 22 12c0-.67-.069-1.325-.195-1.959"
            ></path>
        </svg>
    ),
    Facebook: () => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
        >
            <g clipPath="url(#a)">
                <path
                    fill="#1877F2"
                    d="M24 12c0-6.627-5.373-12-12-12S0 5.373 0 12c0 5.99 4.388 10.954 10.125 11.854V15.47H7.078V12h3.047V9.356c0-3.007 1.792-4.668 4.533-4.668 1.313 0 2.686.234 2.686.234v2.953H15.83c-1.491 0-1.956.925-1.956 1.874V12h3.328l-.532 3.469h-2.796v8.385C19.612 22.954 24 17.99 24 12"
                ></path>
                <path
                    fill="#fff"
                    d="M16.671 15.469 17.203 12h-3.328V9.75c0-.95.465-1.875 1.956-1.875h1.513V4.922s-1.374-.234-2.687-.234c-2.74 0-4.532 1.66-4.532 4.668V12H7.078v3.469h3.047v8.385a12.1 12.1 0 0 0 3.75 0V15.47z"
                ></path>
            </g>
            <defs>
                <clipPath id="a">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                </clipPath>
            </defs>
        </svg>
    ),
    CheckIcon: () => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="69"
            height="66"
            fill="none"
            viewBox="0 0 69 66"
        >
            <path
                fill="#000"
                fillOpacity="0.1"
                d="M69 32.969 61.347 24.2l1.067-11.597-11.323-2.577L45.164 0 34.5 4.589 23.836 0 17.91 10.026 6.586 12.57 7.653 24.2 0 32.969l7.653 8.768-1.067 11.629 11.323 2.577L23.836 66 34.5 61.38l10.664 4.589 5.927-10.026 11.323-2.577-1.067-11.597zM56.611 37.62l-1.756 2.043.25 2.671.566 6.129-8.594 1.948-1.38 2.326-3.105 5.28-5.583-2.42L34.5 54.53l-2.478 1.068-5.582 2.42-3.106-5.248-1.38-2.326-8.593-1.949.564-6.16.251-2.671-1.756-2.043L8.374 33l4.046-4.651 1.756-2.043-.282-2.703-.565-6.097 8.594-1.949 1.38-2.326 3.105-5.28 5.583 2.42L34.5 11.44l2.478-1.069 5.582-2.42 3.105 5.28 1.38 2.326 8.594 1.949-.565 6.128-.25 2.672 1.756 2.043 4.046 4.62z"
            ></path>
            <path
                fill="#000"
                fillOpacity="0.1"
                d="m28.51 38.5-7.277-7.323-4.642 4.683L28.51 47.834l23.022-23.131-4.642-4.683z"
            ></path>
        </svg>
    )

}